import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  // allowing any: don't know how to type 'BsModalRef'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  bsModalRef: any = BsModalRef;

  public submitClicked: BehaviorSubject<boolean> = new BehaviorSubject(false)

  constructor(private modalService: BsModalService) { }

  // allowing any: 'state' is arbitrary object with unknown members & don't know how to type 'component'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openModal(component: any, state?: any) {
    const initialState: ModalOptions = {
      initialState: state
    }

    this.bsModalRef = this.modalService.show(component, initialState);
  }

  closeModal() {
    this.modalService.hide()
  }
}
